var LocaleService = require('services/locale-service');
/**
 * this will be deleted or refactored with new timer service.
 */
class TimerDecorator {
    constructor(countdown, $domEl) {
        this.countdown = countdown || 0;
        this.timeLeft = 0;
        this.currentTime = 0;
        this.interval = null;
        this.$el = $domEl;
    }

    startTimer() {
        /** Basic functionality */
        if (this.countdown > 0) {
            const countDownTime = new Date().getTime() + this.countdown * 1000;
            this.timeLeft = countDownTime - new Date();
            if (this.$el != '') $(this.$el).html(LocaleService.t("Time") + " " + Math.ceil(this.timeLeft / 1000));
            this.interval = setInterval(() => {
                this.timeLeft = countDownTime - new Date();
                if (this.timeLeft > 0) {
                    if (this.$el != '') $(this.$el).html(LocaleService.t("TimeLeft" + "  " + Math.ceil(this.timeLeft / 1000)));
                    this.timeLeft = countDownTime - new Date();
                    this.currentTime = this.timeLeft;
                } else {
                    if (this.$el != '') $(this.$el).html(LocaleService.t("TimeLeft") + "  " + Math.ceil(this.timeLeft / 1000));
                    clearInterval(this.interval);
                    this.currentTime = this.countdown;
                    Chaplin.mediator.publish('timer:done');
                }
            }, 1000);
        } else {
            this.interval = setInterval(() => {
                this.currentTime += 1;
                if (this.$el != '') $(this.$el).html(LocaleService.t("Time") + " " + this.currentTime);
            }, 1000);
        }
    }

    getInterval() {
        return this.interval || null;
    }

    stopTimer() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    resetTimer() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.currentTime = 0;
    }

    getCurrentTime() {
        return this.currentTime;
    }

    dispose() {
        this.stopTimer();
    }
}

export default TimerDecorator;